<template>
    <el-dialog
            class="detail-dialog-container"
            :visible.sync="dialogVisible"
            :before-close="cancel"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="`${tipAdd()}单位`"
            width="500px"
            center>
        <div class="dialog-container flex flex-direction">
            <el-form class="publish-form" :model="ruleForm" :rules="rules" ref="ruleForm" labelWidth="auto">
                <el-form-item prop="company_name" label="单位名称">
                    <el-input v-model="ruleForm.company_name" placeholder="请输入">
                    </el-input>
                </el-form-item>
                <el-form-item class="flex align-center justify-end" label-width="0">
                    <el-button  @click="cancel">取消</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>
</template>

<script>
    import {tipAdd} from "@/utils/utils";
    import {addCompany} from "@/api";

    export default {
        name: "AddUnitsDialog",
        props: {
            dialogVisible: {
                type: Boolean,
                default: false
            },
            uid: { //单位ID
                type: Number,
            },
            type: {
                type: Number,
            },
            company_name: {
                type: String,
            },
        },
        data() {
            return {
                id:0,
                loading: false,
                ruleForm: {
                    company_name: '',
                },
                rules: {
                    company_name: [
                        {required: true, message: '请输入单位名称', trigger: 'blur'}
                    ],
                },
                members: [],
            }
        },
        created() {
            this.init()
        },
        methods: {
            async init() {
               this.ruleForm.company_name = this.company_name
            },
            tipAdd(){
                return tipAdd(this.id,'添加')
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.addItem();
                    }
                });
            },
            async addItem() {
                this.loading = true
                let _data = await addCompany(this.uid,this.ruleForm.company_name, this.type)
                this.loading = false
                if (_data.status === 200) {
                    this.clearContent()
                    this.$message.success(_data.msg)
                    this.$emit('watchState', true)
                }
            },
            clearContent(){
                this.$refs.ruleForm.resetFields()
            },
            cancel() {
                this.clearContent()
                this.$emit('watchState', false)
            },
        },
        watch: {
            company_name() {
                this.init()
            }
        }
    }
</script>

<style scoped lang="scss">

</style>